import { cn } from '@dinewise/utils';

type EventRowSkeletonProps = {
  className?: string;
};

export const EventRowSkeleton = ({ className }: EventRowSkeletonProps) => {
  return (
    <div className={cn('flex animate-pulse items-start gap-3 rounded-2xl py-2', className)}>
      <div className="h-[68px] w-[52px] shrink-0 rounded-xl bg-ande-surface-200" />
      <div className="min-w-0 flex-1 space-y-2 pt-1">
        <div className="flex items-center gap-2">
          <div className="h-5 min-w-0 flex-1 rounded bg-ande-surface-200" />
          <div className="h-5 w-16 shrink-0 rounded-full bg-ande-surface-200" />
        </div>
        <div className="h-4 w-4/5 rounded bg-ande-surface-200" />
      </div>
    </div>
  );
};
